import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "./useAuth";

export function usePartnerContext() {
  const { user } = useAuth();

  const query = useQuery({
    queryKey: ["partner_context", user?.id],
    enabled: !!user?.id,
    queryFn: async () => {
      const { data, error } = await supabase
        .from("partner_users")
        .select("*, partner_orgs(*)")
        .eq("user_id", user!.id)
        .maybeSingle();
      if (error) throw error;
      return data;
    },
  });

  return {
    partnerUser: query.data,
    orgId: query.data?.org_id ?? null,
    org: query.data?.partner_orgs ?? null,
    isLoading: query.isLoading,
    isPartner: !!query.data,
  };
}
